import { render } from "./ActivityIcon.vue?vue&type=template&id=2e27fbf1"
import script from "./ActivityIcon.vue?vue&type=script&lang=ts"
export * from "./ActivityIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script